import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./Badge.module.scss";
/**
 * Badge component displays a badge with text.
 *
 * @example
 * <Badge text="Free Gift" />
 */
export const Badge = (props) => (_jsx("div", { className: styles.badge, ...props, children: _jsx("span", { children: props.text }) }));
//# sourceMappingURL=Badge.js.map